import { FileUploadInterface, FileMetadata } from '@core/objects/storage';
import CryptoES from 'crypto-es';

export class FileUploadQueue {
    static readonly SUCCESS = 2;
    static readonly ERROR = 1;
    static readonly PENDING = 0;

    // Allowed MIME types
    static readonly ALLOWED_IMAGE_TYPES = [
        'image/png',
        'image/jpeg',
        'image/jpg',
        'image/gif'
    ];

    public queue: Array<FileUploadInterface> = [];

    public add(file: FileUploadInterface): boolean {
        if (this.exists(file)) return false;
        return this.queue.push(file) > 0;
    }

    public remove(file: FileUploadInterface) {
        this.queue = this.queue.filter(f => file.hash !== f.hash);
    }

    public exists(file: FileUploadInterface): boolean {
        return this.queue.some(f => f.hash === file.hash);
    }

    public setStatus(file: FileUploadInterface, status: number) {
        this.queue = this.queue.map(f => f.hash === file.hash ? { ...f, status } : f);
    }

    public setProgress(file: FileUploadInterface, progress: number) {
        this.queue = this.queue.map(f => f.hash === file.hash ? { ...f, progress } : f);
    }

    public setFileObject(file: FileUploadInterface, metadata: FileMetadata) {
        this.queue = this.queue.map(f => f.hash === file.hash ? { ...f, metadata } : f);
    }

    public getOnPending(): Array<FileUploadInterface> {
        return this.queue.filter(f => f.status === FileUploadQueue.PENDING);
    }

    public getOnSuccess(): Array<FileUploadInterface> {
        return this.queue.filter(f => f.status === FileUploadQueue.SUCCESS);
    }

    public create(file: File): FileUploadInterface | null {
        const hash = CryptoES.MD5(file.name + file.size).toString();
        const f: FileUploadInterface = {
            file,
            status: FileUploadQueue.PENDING,
            progress: 0,
            hash,
            metadata: null
        };

        if (!this.add(f)) return null;
        return f;
    }

    public clear() {
        this.queue = [];
    }
}
